/**
 * XMLNS is the XML namespace for SVG elements.
 * Exported as a const to preserve space in the minified output.
 */
export const XMLNS = "http://www.w3.org/2000/svg";
